import { Platform, User } from "../../types";
import { api } from "../../services/api";

export interface LinkMethod {
  link: (user: User | null) => void;
  unlink: (user: User | null) => void;
}

export const linkProfileMethods: Record<Platform, LinkMethod> = {
  steam: {
    link: (user) => {
      if (!user?.userId) return;
      const baseUrl = import.meta.env.VITE_REACT_APP_STEAM_LOGIN_URL || "";
      window.location.href =
        `${baseUrl}/api/steam/auth?userId=${encodeURIComponent(
          user.userId
        )}`;
    },
    unlink: async (user) => {
      if (!user?.userId) return;
      await api.app.unlinkSteam();
    },
  },

  playstation: {
    link: (user) => {
      console.log('PSN')
      if (!user?.userId) return;
      // TODO
    },
    unlink: (user) => {
      console.log('implement unlink...')
    },
  },

  xbox: {
    link: (user) => {
      if (!user?.userId) return;
    },
    unlink: (user) => { },
  },

  nintendo: {
    link: (user) => {
      if (!user?.userId) return;
    },
    unlink: (user) => { },
  },
  epicgames: {
    link: (user) => {
      if (!user?.userId) return;
      window.location.href = `/api/epic/auth?userId=${encodeURIComponent(user.userId)}`;
    },
    unlink: async (user) => {
      if (!user?.userId) return;
      await api.app.unlinkEpic();
    },
  },
  discord: {
    link: (user) => {
      if (!user?.userId) return;
      window.location.href = `/api/discord/auth?userId=${encodeURIComponent(user.userId)}`;
    },
    unlink: async (user) => {
      if (!user?.userId) return;
      await api.app.unlinkDiscord();
    },
  },
};